"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const string_utils_1 = require("@/common/string_utils");
function default_1(paymentDetail) {
    const { room_second_paid, second_status_cd_id, room_second_start_date, room_second_end_date, waybill, } = paymentDetail;
    const nowTime = new Date().getTime();
    const secondStartTime = new Date((0, string_utils_1.changeKSTToLocalTime)(room_second_start_date)).getTime();
    const secondEndTime = new Date((0, string_utils_1.changeKSTToLocalTime)(room_second_end_date)).getTime();
    const isForceComplete = !!(waybill === null || waybill === void 0 ? void 0 : waybill.name);
    if (room_second_paid) {
        if (isNaN(secondStartTime) && isNaN(secondEndTime)) {
            return 'secondPaymentExpected';
        }
        else {
            if (nowTime < secondStartTime)
                return 'secondPaymentPending';
            else if (second_status_cd_id === 'SECOND_PAYMENT_STATUS_02') {
                return 'secondPaymentSuccess';
            }
            else if (secondStartTime <= nowTime && nowTime < secondEndTime) {
                if (isForceComplete) {
                    return 'secondPaymentWasted';
                }
                else if (second_status_cd_id === 'SECOND_PAYMENT_STATUS_00') {
                    return 'secondPaymentStart';
                }
                else if (second_status_cd_id === 'SECOND_PAYMENT_STATUS_01') {
                    return 'secondPaymentVBank';
                }
            }
            else if (secondEndTime <= nowTime)
                return 'secondPaymentWasted';
        }
    }
    return '';
}
exports.default = default_1;
